import React, {useRef, useState} from "react";
import {validateMode} from "root/Modals/modalFunctions";
import Modal from "react-responsive-modal";
import ModalEditUser from "root/s360components/Modals/UserEdit/ModalEditUser";
import {useForm} from "react-hook-form";

export const ModalEditUserModes = {
    RENAME: 'rename',
}

export const EditUserSubFormIdentifiers = {
    RENAME: 'rename'
}

export const EditUserFieldNames = {
    USERNAME: 'username'
}



const useModalEditUser = () =>
{
    const defaultState =  { openState: false, mode: null, enc_user_id: null, user_type: null } ;

    const [dialog, setDialog]  = useState ( defaultState )  ;

    //Success of submission
    const resolvePromise = useRef(null);

    const onClickActivate = ( { mode, enc_user_id, user_type } ) =>
    {
        validateMode(mode, ModalEditUserModes);

        return new Promise((resolve, reject) => {

            resolvePromise.current = resolve ;

            switch ( mode )
            {
                case ModalEditUserModes.RENAME:
                    setDialog ({ openState: true, mode: mode, enc_user_id: enc_user_id, user_type: user_type});
                    break ;
            }
        })
    }

    const onCloseModal = () =>
    {
        setDialog (defaultState);

        if ( resolvePromise.current !== null )
        {
            resolvePromise.current ( 'cancel' ) ;
        }
    };

    const onSaveComplete = ( result ) =>
    {
        // Close the dialog
        setDialog (defaultState);

        // Tell the parent we're done
        if ( resolvePromise.current !== null )
        {
            resolvePromise.current ( result ) ;
        }
    };

    const render = ( ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                < ModalEditUser onClose={onCloseModal} enc_user_id={dialog.enc_user_id} user_type={dialog.user_type} mode={dialog.mode} onSaveComplete={onSaveComplete}/>
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalEditUser;
